module.exports = __webpack_public_path__ + "static/media/filled-ball.9e295d1a.svg";